import { Outlet } from 'react-router';
import { Header } from './Header';

export const CoreLayout = () => {
  return (
    <div className="h-screen bg-gradient-main flex flex-col">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
    </div>
  );
};
